import { Alpine } from "alpinejs";

document.addEventListener('alpine:init', () => {
    Alpine.store('global', {
        address:  Alpine.$persist(''),
        lat:  Alpine.$persist(''),
        lng:  Alpine.$persist(''),
        electorate:  Alpine.$persist(''),
        setAddress(value) {
            this.address = value
        },
        setLat(value) {
            this.lat = value
        },
        setLng(value) {
            this.lng = value
        },
        setElectorate(value) {
            this.electorate = value
        },
        clearAddress() {
            this.address = '';
            this.lat = '';
            this.lng = '';
            this.electorate = '';
        }
    })
});